module.exports = __webpack_public_path__ + "img/backyard-cross-angle.ab0ad778.jpg";